// src/pages/Verify.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import Navbar from '../components/Navbar';
import API from '../utils/api';

const Verify = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await API.get(`/auth/verify/${token}`);
        localStorage.setItem('token', response.data.token);  // Auto-login on verify
        toast.success('Email verified! Logging you in.');
        navigate('/dashboard');
      } catch (error) {
        toast.error('Verification failed—try registering again.');
        navigate('/register');
      } finally {
        setLoading(false);
      }
    };
    verify();
  }, [token, navigate]);

  if (loading) return <div className="min-h-screen bg-white flex items-center justify-center"><Navbar /><p>Verifying...</p></div>;

  return null;  // Redirects immediately
};

export default Verify;